import { extractXlsxTextBrowser as extractXlsxText } from "@/services/xlsx-extract";

/**
 * Extrai texto de um arquivo XLSX/XLS no navegador
 * @param file Arquivo XLSX/XLS
 * @returns Texto extraído da planilha
 */
export async function extractXlsxTextBrowser(file: File): Promise<string> {
  return extractXlsxText(file);
}
